// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"272":"collectPortalConfig","960":"collectEmailConfig"}[chunkId] || chunkId) + "." + {"160":"5744884d","164":"46aba17b","272":"91f3fc69","520":"cd81baa9","680":"3a0cea82","848":"7e2ec7dd","960":"c1f30f89"}[chunkId] + ".css";
};